import React from "react";
import { RouteConfig } from "../../../../config/router/router.config";
import { IOrganization } from "../../../../model/organization/organization.model";

export type OrganizationEditRouteParam = {
  organization: IOrganization;
};

export const organizationEditRoute: RouteConfig = {
  name: "Edit Organization",
  Component: React.lazy(() => import("./OrganizationEdit.view")),
  path: "/organization/edit/:id",
  isPrivate: true,
};
